import React from "react";
import Async from "react-select";
import Field from "../../Common/Field/Field";
import App from "../../../pages/report/multiSelect";
import Picky from "react-picky"
import "react-picky/dist/picky.css"

//sample awaiting material
const ProcessUpdatesForm = props => {
  return (
    <div className="col-md-12 text-center">
      <span>
        <div className="col-md-12 d-flex justify-content-center">
          <div className="col-md-3 px-2" style={{ zIndex: "1000" }}>
            <label>Customer department</label>
            <App
              customerInfo={props.customerWithDepartment}
              selectedCustomers={props.storeCustomerData}
            />
          </div>
          <div className="col-md-2" style={{ zIndex: "1000" }}>
            <label>ETA/ETD From</label>
            <Field
              inputType="date"
              inputName="fromDate"
              label="from Date"
              value={props.fromDate}
              onChange={props.updateState}
              disabled={false}
              className="Select-control"
            />
          </div>
          <div className="col-md-2" >
            <label>ETA/ETD To</label>
            <Field
              inputType="date"
              inputName="toDate"
              label="to Date"
              value={props.toDate}
              onChange={props.updateState}
              disabled={false}
              className="Select-control"
            />
          </div>
        </div>
        <div className="col-md-12 d-flex justify-content-center p-1">
          <div className="col-md-3">
            <label>Process Type</label>
            <Field
              inputType="select"
              inputName="processType"
              value={props.processType}
              options={props.processTypeOptions}
              onChange={props.updateState}
              disabled={false}
              className="Select-control"
            />
          </div>
          <div className="col-md-3" style={{ zIndex: "1000" }}>
            <label>Style Ref No.</label>
            <div className="custom-async-select style-reference-select">
              <Async
                name="styleReferenceId"
                multi
                value={props.styleReferenceId || []}
                onInputChange={props.getMagnumStyleNo}
                onChange={props.updateStyleReference}
                placeholder="Find Style"
                options={props.styleNoInfo || []}
                onSelectResetsInput={false}
                onBlurResetsInput={false}
              />
            </div>
          </div>
          <div className="col-md-3">
            <label>Source of request</label>
            <Field
              inputType="select"
              inputName="typeOfRequest"
              value={props.typeOfRequest}
              options={props.typeOfRequestOptions}
              onChange={props.updateState}
              disabled={false}
              className="Select-control"
            />
          </div>
          <div className="col-md-3">
            <label>Sample Type</label>
            {/* <Field
              inputType="select"
              inputName="sampleType"
              value={props.sampleType}
              options={props.sampleTypeOptions}
              onChange={props.updateState}
              disabled={false}
              className="Select-control"
            /> */}
            <Picky
              value={props.arrayValue2}
              options={props.sampleTypeOptions}
              onChange={props.selectMultipleOption2}
              open={false}
              valueKey="value"
              labelKey="label"
              multiple={true}
              includeSelectAll={true}
              manySelectedPlaceholder={"%s selected"} 
              allSelectedPlaceholder={"%s selected"}
              includeFilter={true} 
              dropdownHeight={300}
              placeholder="Select a sample type" 
              disabled={false}
          />
          </div>
        </div>
      </span>
    </div>
  );
};

export default ProcessUpdatesForm;


// WEBPACK FOOTER //
// ./src/components/Report/forms/ProcessUpdatesForm.js